import { useQuery } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { apiKeyKeys } from '../constants';
import type { ApiKeyViewModel } from '../types';

export const useGetApiKeyMetadata = () => {
  return useQuery<ApiKeyViewModel | null, Error>({
    queryKey: apiKeyKeys.me,
    queryFn: async () => {
      try {
        const response =
          await bffApiClient.get<ApiKeyViewModel>('/api/api-keys/me');
        return response.data;
      } catch (error: any) {
        if (error?.response?.status === 404) return null;
        throw error;
      }
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000
  });
};
